import { theme, Grid } from "@project/shared"
import { Card } from "../Card"
import styled from "styled-components"
import moment from "moment"
import { Collapse } from "antd"
import { DownOutlined } from "@ant-design/icons"

const GridContainer = styled.div`
  margin-top: 20px;
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  .inner-grid-content div {
    color: black;
  }

  @media screen and (max-width: 426px) {
    .last-container {
      border-left: 1px solid #d2d2d2;
      border-bottom: 1px solid #d2d2d2;
      border-top: none;
    }
  }
`

const { Panel } = Collapse

interface DateCardProps {
  title?: string
  content?: string
  expandTitle?: string
  expandText?: string
  station?: string
  dates?: Date[]
  borderColor?: string
  icon?: string
  isPanel?: boolean
  showDate?: boolean
  showRegisterFacility?: boolean
}

const StyledCollapse = styled(Collapse)<{ borderColor?: string }>`
  @media screen and (max-width: 600px) {
    * {
      font-size: 12px;
    }
    & .ant-collapse-content-box {
      padding-top: 6px !important;
      padding-bottom: 6px !important;
    }
  }
  .ant-collapse-item > .ant-collapse-header {
    padding: 0;
    color: ${theme.red2};
    margin-top: 12px;
    text-decoration: underline;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 8px;
  }
  .ant-collapse-item > .ant-collapse-content {
    padding: 0;
    color: ${theme.red1};
  }
`

const StationDate = styled.div`
  border: 1px solid ${theme.gray2};
  display: grid;
  margin-top: 12px;
  grid-template-columns: 1fr 5fr;
  color: ${theme.black};
  * {
    grid-row: 1;
    padding: 10px 20px;
    font-size: 16px;
  }
  .station {
    border-right: 1px solid ${theme.gray2};
    background-color: ${theme.gray};
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 2fr 4fr;
    * {
      font-size: 12px;
    }
  }
`

export const DateCard = ({
  title,
  content,
  expandTitle,
  expandText,
  station,
  dates,
  icon,
  isPanel = true,
  showDate,
  showRegisterFacility,
}: DateCardProps) => {
  return (
    <Card title={title} content={content} icon={icon} color={"blue"}>
      <StyledCollapse
        className={"expand-title"}
        ghost
        expandIcon={() => (
          <DownOutlined
            style={{
              verticalAlign: "middle",
            }}
          />
        )}
      >
        {isPanel === false ? (
          ""
        ) : (
          <Panel header={expandTitle} key={1}>
            <p style={{ marginBottom: 0 }}>{expandText}</p>
            {/* Implement Station picker? */}
            {showRegisterFacility ? (
              <GridContainer>
                <Grid className={"grid_layout"} width={"200px"} background>
                  <div>{"(放) 小泉"}</div>
                </Grid>
                <Grid className={"flex-full grid-row-last last-container"}>
                  <div>{"2023年03月"}</div>
                </Grid>
                <Grid className={"flex-break"}></Grid>
                <Grid className={"grid_layout"} width={"200px"} background>
                  <div>{"太田"}</div>
                </Grid>
                <Grid className={"flex-full grid-row-last last-container"}>
                  <div>{"2023年03月"}</div>
                </Grid>
                <Grid className={"flex-break"}></Grid>
                <Grid className={"grid_layout"} width={"200px"} background>
                  <div>{"太田"}</div>
                </Grid>
                <Grid className={"flex-full grid-row-last last-container"}>
                  <div>{"2023年03月"}</div>
                </Grid>
                <Grid className={"flex-break"}></Grid>
                <Grid className={"grid_layout"} width={"200px"} background>
                  <div>{"太田"}</div>
                </Grid>
                <Grid className={"flex-full grid-row-last last-container"}>
                  <div>{"2023年03月"}</div>
                </Grid>
                <Grid className={"flex-break"}></Grid>
                <Grid className={"grid_layout"} width={"200px"} background>
                  <div>{"太田"}</div>
                </Grid>
                <Grid className={"flex-full grid-row-last last-container"}>
                  <div>{"2023年03月"}</div>
                </Grid>
                <Grid className={"flex-break"}></Grid>
              </GridContainer>
            ) : station ? (
              <StationDate>
                <div className={"station"}>{station}</div>
                {/* Implement datepicker */}
                {dates ? (
                  <div className={"datepicker"}>
                    {dates
                      .map((date) => moment(date).format("YYYY年MM月"))
                      .join(" ")}
                  </div>
                ) : (
                  ""
                )}
              </StationDate>
            ) : (
              ""
            )}
          </Panel>
        )}
        {showDate && (
          <GridContainer>
            <Grid className={"grid_layout"} width={"200px"} background>
              <div>{"太田"}</div>
            </Grid>
            <Grid className={"flex-full grid-row-last last-container"}>
              <div>{"2023年03月"}</div>
            </Grid>
          </GridContainer>
        )}
      </StyledCollapse>
    </Card>
  )
}
